import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function BlogDetail() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false)); }, [slug]);

    if (post === false) return <div className="mx-container py-40 text-center text-neutral-500">Article not found.</div>;
    if (!post) return <div className="mx-container py-40 text-center"><div className="h-8 w-8 mx-auto rounded-full border-2 border-neutral-200 border-t-ink animate-spin" /></div>;

    return (
        <article data-testid="blog-detail-page">
            <section className="bg-cream py-16 lg:py-24 border-b border-[#e8e1d4]">
                <div className="mx-container max-w-3xl">
                    <Link to="/blog" className="inline-flex items-center gap-1.5 text-neutral-400 hover:text-ink text-sm mb-6"><ArrowLeft className="h-4 w-4" /> Journal</Link>
                    <p className="overline mb-4">{post.category} · {post.read_time}</p>
                    <h1 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl leading-[1.02]">{post.title}</h1>
                    <p className="mt-5 text-neutral-500 text-sm">{post.author} · {new Date(post.date).toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" })}</p>
                </div>
            </section>
            <div className="mx-container max-w-3xl py-12">
                <div className="relative overflow-hidden aspect-[16/9] mb-10">
                    <img loading="lazy" decoding="async" src={post.cover} alt={post.title} className="h-full w-full object-cover" />
                </div>
                <p className="text-xl text-neutral-800 leading-relaxed font-medium mb-6">{post.excerpt}</p>
                <p className="text-lg text-neutral-600 leading-relaxed">{post.body}</p>
            </div>
        </article>
    );
}
